import { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import { format } from 'date-fns'
import { zhTW } from 'date-fns/locale'
import { AdScheduleTemplate } from '@/hooks/useAdScheduleTemplates'
import ActionCell from './ActionCell'

export const columns: ColumnDef<AdScheduleTemplate>[] = [
  {
    accessorKey: 'template_name',
    header: '模版名稱',
    cell: ({ row }) => {
      return <div className="font-medium">{row.original.template_name}</div>
    },
  },
  {
    accessorKey: 'description',
    header: '描述',
    cell: ({ row }) => {
      return <div className="text-muted-foreground">{row.original.description || '-'}</div>
    },
  },
  {
    accessorKey: 'slots',
    header: '梯次數量',
    cell: ({ row }) => {
      const activeSlots = row.original.slots.filter((slot) => slot.is_active)
      return <Badge variant="secondary">{activeSlots.length} 個梯次</Badge>
    },
  },
  {
    accessorKey: 'is_active',
    header: '狀態',
    cell: ({ row }) => {
      return row.original.is_active ? (
        <Badge className="bg-green-500">啟用</Badge>
      ) : (
        <Badge variant="secondary">停用</Badge>
      )
    },
  },
  {
    accessorKey: 'created_at',
    header: '建立時間',
    cell: ({ row }) => {
      return format(new Date(row.original.created_at), 'yyyy/MM/dd HH:mm', {
        locale: zhTW,
      })
    },
  },
  {
    id: 'actions',
    header: '操作',
    cell: ({ row, table }) => {
      return <ActionCell template={row.original} onRefresh={table.options.meta?.onRefresh} />
    },
  },
]
